import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LockKeyhole, ShieldCheck } from "lucide-react";
import useDocumentMeta from "../hooks/useDocumentMeta";
import { loginAdmin } from "../lib/api";
import { setAdminToken } from "../lib/adminAuth";

const AdminLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useDocumentMeta({
    title: "FindClarity Admin Login",
    description: "Secure admin access for FindClarity blog publishing.",
  });

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    setError("");

    try {
      const response = await loginAdmin({ username, password });
      setAdminToken(response.access_token);
      const nextPath = location.state?.from?.pathname || "/admin/blogs";
      navigate(nextPath, { replace: true });
    } catch (loginError) {
      setError("Login failed. Please check your admin credentials.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="admin-login-page">
      <div className="admin-login-shell">
        <section className="admin-login-card">
          <div className="admin-login-copy">
            <span className="dashboard-eyebrow">
              <ShieldCheck size={16} />
              Admin Access Only
            </span>
            <h1>Secure blog publishing for authorized FindClarity admins.</h1>
            <p>
              This area is reserved for approved team members who manage
              cornerstone content and publish articles to the live website.
            </p>
          </div>

          <form className="admin-login-form" onSubmit={handleSubmit}>
            <div className="dashboard-panel-header">
              <LockKeyhole size={18} />
              <h2>Admin Login</h2>
            </div>

            <label className="dashboard-field">
              <span>Username</span>
              <input
                value={username}
                onChange={(event) => setUsername(event.target.value)}
                placeholder="Admin username"
                autoComplete="username"
                required
              />
            </label>

            <label className="dashboard-field">
              <span>Password</span>
              <input
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="Admin password"
                autoComplete="current-password"
                required
              />
            </label>

            {error && <p className="admin-login-error">{error}</p>}

            <button
              type="submit"
              className="dashboard-submit-button admin-login-button"
              disabled={submitting}
            >
              {submitting ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </section>
      </div>
    </div>
  );
};

export default AdminLogin;
